module.exports = __webpack_public_path__ + "static/media/email.c3dc1303.svg";